import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=0ab8839a&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=0ab8839a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab8839a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ab8839a')) {
      api.createRecord('0ab8839a', component.options)
    } else {
      api.reload('0ab8839a', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=0ab8839a&scoped=true", function () {
      api.rerender('0ab8839a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/menu/menu.vue"
export default component.exports